// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "核反应堆工程",
      "tec": "赵国志",
      "week": "1-8周",
      "add": "教学楼C座304教务"
    },
    {
      "sub": "核技术应用",
      "tec": "覃国秀毕垒",
      "week": "1-8周",
      "add": "教学楼B座422能动"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "先进核电站机组技术",
      "tec": "刘丰",
      "week": "1-10,12-13周",
      "add": "教学楼C座305教务"
    },
    {
      "sub": "核工程检测仪表",
      "tec": "李伟哲",
      "week": "1-6周",
      "add": "教学楼C座302教务"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "核反应堆工程",
      "tec": "赵国志",
      "week": "1-8周",
      "add": "教学楼C座303教务"
    },
    {
      "sub": "核技术应用",
      "tec": "覃国秀毕垒",
      "week": "1-8周",
      "add": "教学楼B座322能动"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "核反应堆热工水力学",
      "tec": "刘丰",
      "week": "1-10,12-13周",
      "add": "教学楼C座303教务"
    },
    0,
    0,
    0,
    0
  ],
  "5": [
    0,
    {
      "sub": "核工程检测仪表",
      "tec": "李伟哲",
      "week": "1-6周",
      "add": "教学楼B座423能动"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
